import React from "react";
import Icon from "../../dashboard/Icon/Icon";
import "./speedometer.css";
import ThresholdBG from "./ThresholdsBG/ThresholdBG";
import Title from "../ReusableComponents/Title/Title";
const SpeedoMeterPreview = ({ configData = {} }) => {
  const { config = {} } = configData;
  const { name, icon = {} } = config;
  const iconImgName = icon?.imgName || "lsq_copy";
  return (
    <div className="speedo-meter">
      <div className="speedo-meter-container">
        <div className="speedo-meter-bg">
          <ThresholdBG configData={configData} />
        </div>
        {config?.count > -1 && (
          <div className="count-content">
            <span className="count ng_d_3_b">{config?.count}</span>
            <div className="max-count ng_p_1_m">
              {config?.maxCount > 0 && `Out of ${config.maxCount}`}
            </div>
          </div>
        )}
      </div>
      <Title className="title" text={name || "Tasks"} />
      <Icon className="icon" src={`images/${iconImgName}.svg`} alt="icon" />
    </div>
  );
};

export default SpeedoMeterPreview;
